<template>
  <div
    v-if="$store.getters.marchand && $store.getters.marchand._env === 'live'"
    class="row"
    style="padding: 5px"
  >
    <div class="col-12 mb-4">
      <div class="pb-4">
        <v-btn
          @click="$router.go(-1)"
          outlined
          style="border: none; background: #fff"
          title="Retourner"
        >
          <v-icon>mdi mdi-arrow-left-thin</v-icon> Retour
        </v-btn>
      </div>
      <v-card elevation="0" class="mt-4">
        <v-data-table
          :headers="headers"
          :items="classes"
          :search="search"
          sort-by="label"
          class="elevation-1"
          :loading="loadings.classes"
          loading-text="Chargement en cours..."
        >
          <template v-slot:item.img="{}">
            <v-col cols="auto" class="px-0 py-0">
              <v-img
                src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                lazy-src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                width="30"
                height="30"
                class="align-center"
                rounded
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </template>
          <template v-slot:item._created_at="{ item }">
            {{ new Date(item._created_at).toLocaleDateString() }}
          </template>

          <template v-slot:item.montantAPayer="{ item }">
            {{ item.paymentStats.montantAPayer }} XOF
          </template>
          <template v-slot:item.resteAPayer="{ item }">
            {{ item.paymentStats.resteAPayer }} XOF
          </template>
          <template v-slot:item.montantPaye="{ item }">
            {{ item.paymentStats.montantPaye }} XOF
          </template>

          <template v-slot:item.statusPaiement="{ item }">
            <v-chip
              v-if="item._status_payment"
              class="text-white"
              small
              color="green"
              >payer</v-chip
            >
            <v-chip v-else class="text-white" small color="warning">{{
              "en attente"
            }}</v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <div style="text-align: right">
              <v-menu key="text" rounded="b-xl">
                <template v-slot:activator="{ attrs, on }">
                  <v-icon class="black--text" v-bind="attrs" v-on="on"
                    >mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(action_item, index) in actions_items"
                    :key="index"
                    link
                    @click="editItemAction(item, index)"
                  >
                    <v-list-item-icon>
                      <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="action_item.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>

          <template v-slot:top>
            <v-row style="background: #f8f8f8">
              <v-col cols="12" sm="4">
                <v-text-field
                  solo
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row style="background: #f8f8f8">
              <v-toolbar flat>
                <v-toolbar-title
                  >Elèves / Étudiants de la classe / filière
                  {{ schoolClass?._name }}
                </v-toolbar-title>
                <v-spacer />
                <v-dialog v-model="dialogCustomer" max-width="700px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="classestep = 1"
                    >
                      Ajouter un élève / étudiant
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-form ref="clientForm" v-model="clientFormIsValid">
                        <v-container v-show="classestep === 1">
                          <v-row>
                            <v-col lg="12">
                              <h3 class="pb-0">
                                Ajouter un nouvel élève / étudiant en classe /
                                filière
                                {{ schoolClass?._name }}
                              </h3>
                            </v-col>
                            <v-col lg="6" sm="12">
                              <label for="">Prénom</label>
                              <v-text-field
                                solo
                                v-model="studentToSave._firstName"
                                label="Prénom"
                                :rules="requiredRules"
                              ></v-text-field>
                            </v-col>

                            <v-col lg="6" sm="12">
                              <label for="">Nom</label>
                              <v-text-field
                                solo
                                v-model="studentToSave._lastName"
                                label="Nom"
                                :rules="requiredRules"
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" lg="6">
                              <label>Numéro de téléphone </label>
                              <vue-phone-number-input
                                :preferred-countries="['BJ']"
                                :only-countries="['BJ']"
                                default-country-code="BJ"
                                show-code-on-list
                                clearable
                                v-model="tel"
                                :translations="{
                                  countrySelectorLabel: 'Code pays',
                                  countrySelectorError: 'Choisir un pays',
                                  phoneNumberLabel: 'Numéro de téléphone',
                                  example: 'Exemple :',
                                }"
                                @update="getphoneresult"
                              />
                            </v-col>

                            <v-col lg="6" sm="12">
                              <label for="">Genre</label>
                              <v-autocomplete
                                solo
                                :rules="requiredRules"
                                v-model="studentToSave._gender"
                                :items="['Masculin', 'Féminin']"
                                label="Sélectionnez un genre"
                                dense
                                persistent-hint
                              >
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-container>
                        <v-container v-show="classestep === 2">
                          <v-row>
                            <v-col lg="12">
                              <h3 class="pb-5">
                                {{
                                  editingParent
                                    ? "Modifier le parent"
                                    : "Ajouter un parent d'élève"
                                }}
                              </h3>
                            </v-col>
                            <v-col lg="6" sm="12">
                              <label for="">Prénom</label>
                              <v-text-field
                                solo
                                v-model="parentToSave._firstName"
                                label="Prénom"
                                :rules="requiredRules"
                              ></v-text-field>
                            </v-col>

                            <v-col lg="6" sm="12">
                              <label for="">Nom</label>
                              <v-text-field
                                solo
                                v-model="parentToSave._lastName"
                                label="Nom"
                                :rules="requiredRules"
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" lg="6">
                              <label>Numéro de téléphone </label>
                              <vue-phone-number-input
                                :preferred-countries="['BJ']"
                                :only-countries="['BJ']"
                                default-country-code="BJ"
                                show-code-on-list
                                clearable
                                v-model="parentTel"
                                :translations="{
                                  countrySelectorLabel: 'Code pays',
                                  countrySelectorError: 'Choisir un pays',
                                  phoneNumberLabel: 'Numéro de téléphone',
                                  example: 'Exemple :',
                                }"
                                @update="getParentPhoneresult"
                              />
                            </v-col>
                            <v-col lg="6" sm="12">
                              <label for="">Email</label>
                              <v-text-field
                                solo
                                v-model="parentToSave._email"
                                label="Email"
                                :rules="requiredRules"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="dark"
                        @click="
                          (dialogCustomer = false), (editingCustomer = false)
                        "
                      >
                        Annuler
                      </v-btn>

                      <v-btn
                        v-if="classestep === 2"
                        color="secondary"
                        @click="classestep -= 1"
                      >
                        Précédent
                      </v-btn>

                      <v-btn
                        v-if="!editingCustomer"
                        :loading="loadings.student_saving"
                        color="primary"
                        :disabled="
                          studentToSave._firstName === null ||
                          studentToSave._lastName === null ||
                          studentToSave._phoneNumber === null ||
                          studentToSave._gender === null
                        "
                        @click="
                          classestep === 1 ? (classestep += 1) : saveStudent()
                        "
                      >
                        {{ classestep === 1 ? "Suivant" : "Enregistrer" }}
                      </v-btn>
                      <v-btn
                        v-if="editingCustomer"
                        :loading="loadings.student_saving"
                        :disabled="
                          studentToSave._firstName === null ||
                          studentToSave._lastName === null ||
                          studentToSave._phoneNumber === null ||
                          studentToSave._gender === null
                        "
                        color="primary"
                        @click="
                          classestep === 1 ? (classestep += 1) : updateStudent()
                        "
                      >
                        {{ classestep === 1 ? "Suivant" : "Mettre à jour" }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </v-row>
          </template>
          <template v-slot:no-data>
            <span>{{ $t("students.notFound") }}</span>
          </template>
        </v-data-table>
        <!-- <div class="col-12 text-right" style="background: #f8f8f8">
          <v-pagination
            elevation="0"
            v-model="page"
            :length="total_pages"
            :total-visible="7"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="getMarchandCustomers"
          ></v-pagination>
           product pagination
        </div> -->
      </v-card>
    </div>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import GoToParams from "../administrators/globalComponents/GoToParams";
import { client } from "../../store/services/client";
import { fontAwesomePicker } from "font-awesome-picker";
import Swal from "sweetalert2";

export default {
  components: {
    GoToParams,
    "font-awesome-picker": fontAwesomePicker,
  },
  label: "Customers",
  data() {
    return {
      classestep: 1,
      editingCustomer: false,
      editingParent: false,
      clientFormIsValid: false,
      transactionInProgress: false,
      requiredRules: [(v) => !!v || "Ce champ est recquis"],
      loadings: {
        classes: false,
        categories: false,
        categoriySaving: false,
        student_saving: false,
      },
      whatsapp: "",
      tel: "",
      parentTel: "",
      notifier_whatsapp: "",
      notifier_tel: "",
      dialogTransaction: false,
      produits: [],
      classes: undefined,
      fees: [],
      schoolClass: undefined,
      school: undefined,
      all_classes: undefined,
      dialogDelete: false,
      dialogCustomer: false,
      dialogParent: false,
      id: undefined,
      studentId: "",
      studentToSave: {
        _class: "",
        _firstName: "",
        _lastName: "",
        _phoneNumber: "",
        _gender: "",
      },
      parentToSave: {
        _firstName: "",
        _lastName: "",
        _phoneNumber: "",
        _email: "",
      },
      headers: [
        { text: "", value: "img" },
        { text: "Nom", value: "_lastName" },
        { text: "Prénom", value: "_firstName" },
        { text: "Genre", value: "_gender" },
        { text: "Montant dû", value: "montantAPayer" },
        {
          text: "Montant payer",
          value: "montantPaye",
        },
        { text: "Reste à payer", value: "resteAPayer" },
        { text: "Status de paiement", value: "statusPaiement" },
        { text: "", value: "actions" },
      ],
      editedIndex: -1,
      editedItem: {},
      actions_items: [
        {
          title: "Réduction",
          avatar: "mdi-tray-minus",
        },
        {
          title: "Finances",
          avatar: "mdi-finance",
        },

        /*  { title: "Pofile", avatar: "mdi-card-account-details" }, */
        { title: "Modifier", avatar: "mdi-pencil" },
        { title: "Supprimer", avatar: "mdi-delete" },
      ],
    };
  },
  mounted() {
    this.initialize();
  },

  methods: {
    editItemAction(item, index) {
      switch (index) {
        case 0:
          this.$router.push({
            name: "intramScholar.reduction.fees",
            params: {
              student_id: item._id,
              class_id: this.$route.params.class_id,
            },
          });
          break;
        case 1:
          this.$router.push({
            name: "intramScholar.student.details",
            params: { student_id: item._id },
          });
          break;
        case 2:
          this.toggleEditStudent(item);
          break;
        case 3:
          this.toggleDeleteStudent(item);
          break;
      }
    },

    async initialize() {
      this.getAllClassStudents();
      this.getSchoolClass();
    },
    async getSchoolClass() {
      console.log("coming here");
      const response = await client({
        method: "get",
        url: `/school-payments/classes/${this.$route.params.class_id}`,
      })
        .then((resp) => resp.data)
        .catch(() => {
          return {
            error: "true",
          };
        });
      if (!response.error) this.schoolClass = response;

      console.log(this.schoolClass);
    },
    async getAllClassStudents() {
      this.loadings.classes = true;
      let v_box = this;
      const response = await client({
        method: "get",
        url: `/school-payments/students/class/${this.$route.params.class_id}?year=${v_box.$route.query.academic_year}`,
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.classes = false;
          return {
            error: "true",
          };
        });

      if (!response.error) {
        this.loadings.classes = false;
        this.classes = response;
        console.log(this.classes);
      }
    },
    async getAllFees() {
      this.loadings.classes = true;
      const response = await client({
        method: "get",
        url: `/school-payments/fees/school/${this.$route.params.school_id}`,
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.classes = false;
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.loadings.classes = false;
        console.log(response);

        this.fees = response.filter((fee) => fee._defaultValue == null);

        console.log(this.fees);
      }
    },
    async saveStudent() {
      if (this.$refs.clientForm.validate()) {
        this.studentToSave._academicYear = this.$route.query.academic_year;
        this.loadings.student_saving = true;
        this.studentToSave._class = this.$route.params.class_id;
        const response = await client({
          method: "post",
          url: "/school-payments/students/",
          data: {
            student: this.studentToSave,
            parent: this.parentToSave,
          },
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            this.toast(
              "info",
              resp && resp.data._academicYear
                ? "Opération effectuée avec succès !"
                : "Une erreur est survenue au cours du processus !"
            );
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });

        this.loadings.student_saving = false;
        this.dialogCustomer = false;
        this.getAllClassStudents();
      }
    },
    async updateParent() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.student_saving = true;
        const response = await client({
          method: "PUT",
          url: `/school-payments/students/${this.id}`,
          data: this.studentToSave,
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.student_saving = false;
        this.editingParent = false;
        this.dialogParent = false;
        this.getAllClassStudents();
        this.toast(response.type, response.message);
      }
    },
    async updateStudent() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.student_saving = true;
        const response = await client({
          method: "PUT",
          url: `/school-payments/students/${this.id}`,
          data: {
            student: this.studentToSave,
            parent: this.parentToSave,
          },
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.student_saving = false;
        this.editingCustomer = false;
        this.dialogCustomer = false;
        this.getAllClassStudents();
        this.toast(response.type, response.message);
      }
    },
    toggleEditStudent(item) {
      this.dialogCustomer = true;
      this.editingCustomer = true;
      this.parentTel = item._parent._phoneNumber.split(" ")[1];
      this.parentToSave = item._parent;
      delete item._parent;
      this.studentToSave = item;
      this.tel = item._phoneNumber.split(" ")[1];
      this.id = item._id;
      console.log(this.id);
    },
    toggleDeleteStudent(item) {
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("delete_warning"),
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
        preConfirm: async () => {
          Swal.showLoading();
          try {
            const response = await client({
              method: "delete",
              url: `/school-payments/students/${item._id}`,
            });
            Swal.hideLoading();
            Swal.fire({
              icon: "success",
              text: "Suppression réussi",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            console.log(response);
            await this.getAllClassStudents();
            return response.data;
          } catch (error) {
            Swal.hideLoading();
            Swal.fire({
              icon: "error",
              text: "Erreur lors de la suppression",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            return { error: "true" };
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          console.log("finish with modal");
          this.getAllClassStudents();
        }
      });
      console.log("finish with modal 2");
    },
    goToUserDetails(id) {
      let url = "/users/" + id;
      this.$router.push(url);
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    deleteItemConfirm() {},
    getClass(item) {
      return `fa fa-2xl fa-${item._icon}`;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
  created() {
    this.checkisDashboard();
    //this.initialize();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style scoped>
.circular--square {
  border-radius: 50%;
}

.circular--square {
  border-radius: 50% 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
}
svg:not(:host).svg-inline--fa,
svg:not(:root).svg-inline--fa {
  font-size: 20px;
}
</style>
